import React, {useEffect, useState, useCallback, useRef} from 'react';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';
import {Menu} from '../../utils/menu/Menu';
import {
  usersAction,
  userDeleteAction,
  userStatusAction,
  userFiredAction,
  userFiredBackAction,
  userChangeDayOffAction, appointmentOfCuratorTempTaskAction
} from '../../actions/usersAction';
import cfg, {
  formatErrors,
  roleNames,
  roleChiefNutritionist,
  userStatuses,
  userStatusFired, userStatusDayOff, coursesUsersFilter, userStatusActive
} from '../../constants';
import {toast} from 'react-toastify';
import {InputSearch} from '../../utils/inputSearch/InputSearch';
import {SortItem} from '../../utils/sortItem/SortItem';
import {ButtonMore} from '../../utils/buttonMore/buttonMore';
import {Pagination} from '../../utils/pagination/Pagination';
import {UserInviteModal} from './utils/UserInviteModal';
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";
import {getSettingsAction} from "../../actions/settingsAction";
import {updateClientsFixCuratorAction} from "../../actions/clientAction";

const Users = (props) => {
  const {user, getUsers, getSettings} = props;
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({});
  const abortRef = useRef(null);
  const [clientsFix, setClientsFix] = useState([]);

  const handleChangeFilter = useCallback((field, value) => {
    setFilter((data) => {
      return {...data, [field]: value, page: 1}
    });
  }, []);

  const handleChangePage = useCallback((value) => {
    setFilter((data) => {
      return {...data, page: value}
    });
  }, []);

  const handleChangeSort = useCallback((sort, sortd) => {
    setFilter((data) => {
      return {...data, sort, sortd}
    });
  }, []);

  // get users list
  const getUsersList = useCallback((filter) => {
    if (abortRef && abortRef.current) {
      abortRef.current.abort();
    }
    const abortNew = new AbortController();
    abortRef.current = abortNew;
    getUsers(filter, abortRef && abortRef.current ? abortRef.current.signal : null).then((data) => {
      abortRef.current = null;
      setItems(data.list || []);
      setTotal(data.total);
      localStorage.setItem('dc_currentUsersFilter', JSON.stringify(filter));
    }).catch(err => {
      if (err.name !== 'AbortError') {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      }
      abortRef.current = null;
    });
  }, [getUsers]);

  const handleDelete = (id) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      props.deleteUser(id).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Пользователь удален', {position: toast.POSITION.BOTTOM_RIGHT});
        getUsersList(filter);
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  const handleBlock = (id, block) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      props.blockUser(id, block).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Пользователь ' + (block ? 'заблокирован' : 'разблокирован'), {position: toast.POSITION.BOTTOM_RIGHT});
        getUsersList(filter);
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFilter({...filter, [name]: Number(value), page: 1});
  };

  const handleFired = (id) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      props.firedUser(id).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Пользователь уволен', {position: toast.POSITION.BOTTOM_RIGHT});
        getUsersList(filter);
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  const handleFiredBack = (id) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      props.firedUserBack(id).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Пользователь восстановлен', {position: toast.POSITION.BOTTOM_RIGHT});
        getUsersList(filter);
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  const handleChangeDayOff = (id, dayOff) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      props.userChangeDayOff(id, dayOff).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Пользователь ' + (dayOff ? 'отправлен на выходной':'возвращен на работу'), {position: toast.POSITION.BOTTOM_RIGHT});
        getUsersList(filter);
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  const handleAppointmentOfCuratorTempTask = () => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      props.appointmentOfCuratorTempTask().then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Перераспределение', {position: toast.POSITION.BOTTOM_RIGHT});
        getUsersList(filter);
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  const handleResetCuratorTemp = () => {
    if (loading) {
      return false;
    }

    setLoading(true);
    props.updateClientsFixCurator().then(() => {
      setLoading(false);
      getSettingsInfo();
      toast.success('Изменения сохранены', {position: toast.POSITION.BOTTOM_RIGHT});
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }

  // get settings
  const getSettingsInfo = useCallback(() => {
    getSettings().then((data) => {
      setClientsFix(data.clients_fix);
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [getSettings]);

  // get users list on change filter
  useEffect(() => {
    if (filter.page) {
      getUsersList(filter);
    }
  }, [filter, getUsersList]);

  useEffect(() => {
    const baseFilter = {page: 1, limit: 10, search: '', sort: 'email', sortd: 'asc', status: 0, course: 0};
    let curFilter = localStorage.getItem('dc_currentUsersFilter');
    curFilter = curFilter ? JSON.parse(curFilter) : baseFilter;
    curFilter.page = !curFilter.page ? 1 : curFilter.page;
    setFilter(curFilter);
  }, []);

  useEffect(() => {
    getSettingsInfo();
  }, [getSettingsInfo]);

  return <div className="content">
    <Menu isStatic={true}/>

    <div className="heading heading--flex">
      <h2 className="heading__title">Сотрудники</h2>

      {filter.page && filter.page > 0 && <InputSearch className="heading__input"
                                                          value={filter.search}
                                                          loading={loading}
                                                          handleChange={handleChangeFilter} />}

      <select name="status"
              className={"heading__input select"}
              value={filter.status}
              disabled={loading}
              onChange={handleChangeForm}>
        {userStatuses.map(i => <option key={i.value} value={i.value}>{i.text}</option>)}
      </select>

      <select name="course"
              className={"heading__input select"}
              value={filter.course}
              disabled={loading}
              onChange={handleChangeForm}>
        {coursesUsersFilter.map(i => <option key={i.value} value={i.value}>{i.text}</option>)}
      </select>

      <UserInviteModal ok={() => getUsersList(filter)} trigger={<button type="button" className="heading__btn heading__btn--invite btn modal-btn">+ Пригласить сотрудника</button>} />
    </div>
    
    <div className="block-links">
      <div className="block-link"><ConfirmModal trigger={<span className="span-link pointer">Перераспределить временных пользователей</span>} triggerWrap={false} title={"Перераспределить всех клиентов на выходном по кураторам. Данная операция может занять до нескольких минут!"} handleOk={() => handleAppointmentOfCuratorTempTask()}/></div>
      {user.modules && user.modules['Roles'] && <div className="block-link"><Link to={'/roles'} className="span-link">Роли</Link></div>}
      {user.modules && user.modules['Permissions'] && <div className="block-link"><Link to={'/permissions'} className="span-link">Разрешения</Link></div>}
    </div>
    <div className="block-links-clear"></div>

    {clientsFix && <div className="block-show-count-client-fix">
      <div className="block-show-count-client-fix-title">Пользователей с временным куратором, при активным
        постоянном: {clientsFix.length}</div>
      {clientsFix.length > 0 && <div className="block-link-reset" onClick={handleResetCuratorTemp}>Сбросить временного куратора</div>}
    </div>}

    <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="ФИО" className="sort__item--name" sort="last_name" sortd={filter.sort === "last_name" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Телефон" className="sort__item--phone" sort="phone" sortd={filter.sort === "phone" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="E-mail" className="sort__item--email" sort="email" sortd={filter.sort === "email" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Роль" className="sort__item--curator" sort="role_id" sortd={filter.sort === "role_id" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Пользователи" className="sort__item--course"/>
          <SortItem title="Временных пользователей" className="sort__item--course"/>
          <SortItem title="Кол-во активных чатов" className="sort__item--course"/>
          <SortItem title="Статус" className="sort__item--course"/>
          <SortItem title="Заблокирован" className="sort__item--course"/>
        </div>
        <div className="users__inner">
          {
            items && items.length > 0 && items.map((i) => <div key={i.id} className="users__item">
              <div className="users__ava">
                {i.photo && <img src={cfg.public_url + 'auth/file/' + i.id + '/i/' + i.photo} alt="" />}
                {!i.photo && <div className="users__ava--none">{i.first_name.substring(0, 1)}{i.last_name.substring(0, 1)}</div>}
              </div>
              <span className="users__name">{i.last_name} {i.first_name} {i.patronymic_name}</span>
              <span className="users__phone">{i.phone}</span>
              <span className="users__email">{i.email}</span>
              <span className="users__curator">{roleNames[i.role_id - 1]}{i.role_id === roleChiefNutritionist ? ' (Chief)' : ''}</span>
              <span className="users__users">{i.count_clients}</span>
              <span className="users__users">{i.count_clients_temp ? i.count_clients_temp:0}</span>
              <span className="users__users">{i.number_active_chats}</span>
              <span className="users__users">{i.status === userStatusActive ? <ConfirmModal trigger={<span className="span-link active">Активен</span>} triggerWrap={false} title={"Отправить " + i.last_name + " " + i.first_name + " " + i.patronymic_name+" на выходной?"} handleOk={() => handleChangeDayOff(i.id, true)}/>:(i.status === userStatusDayOff ? <ConfirmModal trigger={<span className="span-link day-off">Выходной</span>} triggerWrap={false} title={"Вернуть " + i.last_name + " " + i.first_name + " " + i.patronymic_name+" на работу?"} handleOk={() => handleChangeDayOff(i.id, false)}/>:(i.status === userStatusFired ? "Уволен":"Не активен"))}</span>
              <span className="users__users">{i.block_user ? "Да":"Нет"}</span>
              <ButtonMore>
                <ul className="dropdown">
                  <li className="dropdown__item icon-edit">
                    {user.id !== i.id && <Link to={'/user/' + i.id}>Редактировать</Link>}
                    {user.id === i.id && <Link to={'/profile'}>Редактировать</Link>}
                  </li>
                  {i.block_user && user.id !== i.id && <li className="dropdown__item icon-mark">
                    <ConfirmModal trigger={<span>Разблокировать</span>} triggerWrap={false} title={"Разблокировать пользователя?"} handleOk={() => handleBlock(i.id, false)}/>
                  </li>}
                  {!i.block_user && user.id !== i.id && <li className="dropdown__item dropdown__act--block">
                    <ConfirmModal trigger={<span>Заблокировать</span>} triggerWrap={false} title={"Заблокировать пользователя?"} handleOk={() => handleBlock(i.id, true)}/>
                  </li>}
                  {user.id !== i.id && i.status !== userStatusFired && <li className="dropdown__item icon-delete">
                    <ConfirmModal trigger={<span>Уволить</span>} triggerWrap={false} title={"Уволить пользователя?"} handleOk={() => handleFired(i.id)}/>
                  </li>}
                  {user.id !== i.id && i.status === userStatusFired && <li className="dropdown__item icon-mark">
                    <ConfirmModal trigger={<span>Вернуть уволенного пользователя</span>} triggerWrap={false} title={"Вернуть уволенного пользователя?"} handleOk={() => handleFiredBack(i.id)}/>
                  </li>}
                  {user.id !== i.id && <li className="dropdown__item icon-delete">
                    <ConfirmModal trigger={<span>Удалить</span>} triggerWrap={false} title={"Удалить пользователя?"} handleOk={() => handleDelete(i.id)}/>
                  </li>}
                </ul>
              </ButtonMore>
            </div>)
          }
        </div>
      </div>
    </div>

    {filter.page && filter.page > 0 && <Pagination page={filter.page} total={total} limit={filter.limit} onChange={handleChangePage}/>}
  </div>;
};

const mapStateToProps = (state) => ({
  user: state.user.profile
});

const mapDispatchToProps = (dispatch) => {
  return {
    getUsers(data, signal) {
      return dispatch(usersAction(data, signal));
    },
    deleteUser(id) {
      return dispatch(userDeleteAction(id));
    },
    blockUser(id, block) {
      return dispatch(userStatusAction(id, block));
    },
    firedUser(id) {
      return dispatch(userFiredAction(id));
    },
    firedUserBack(id) {
      return dispatch(userFiredBackAction(id));
    },
    userChangeDayOff(id, dayOff) {
      return dispatch(userChangeDayOffAction(id, dayOff));
    },
    appointmentOfCuratorTempTask(id, dayOff) {
      return dispatch(appointmentOfCuratorTempTaskAction());
    },
    getSettings() {
      return dispatch(getSettingsAction());
    },
    updateClientsFixCurator(id, dayOff) {
      return dispatch(updateClientsFixCuratorAction());
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Users))
